export default __webpack_public_path__ + "static/custom-90bff12ffa6cadb27dc4db2e8b15bcae.png";